import "./chunk.posthog_v20260917.js";
//#region \0vite/preload-helper.js
var scriptRel = /* @__PURE__ */ (function detectScriptRel() {
	const relList = typeof document !== "undefined" && document.createElement("link").relList;
	return relList && relList.supports && relList.supports("modulepreload") ? "modulepreload" : "preload";
})();
var assetsURL = function(dep) {
	return "/" + dep;
};
var seen = {};
var __vitePreload = function preload(baseModule, deps, importerUrl) {
	let promise = Promise.resolve();
	if (deps && deps.length > 0) {
		const links = document.getElementsByTagName("link");
		const cspNonceMeta = document.querySelector("meta[property=csp-nonce]");
		const cspNonce = cspNonceMeta?.nonce || cspNonceMeta?.getAttribute("nonce");
		function allSettled(promises) {
			return Promise.all(promises.map((p) => Promise.resolve(p).then((value) => ({
				status: "fulfilled",
				value
			}), (reason) => ({
				status: "rejected",
				reason
			}))));
		}
		function importMetaResolve(specifier) {
			if (import.meta.resolve) return import.meta.resolve(specifier);
			return new URL(
				specifier,
				/** #__KEEP__ */
				import.meta.url
			).href;
		}
		promise = allSettled(deps.map((dep) => {
			dep = assetsURL(dep, importerUrl);
			dep = importMetaResolve(dep);
			if (dep in seen) return;
			seen[dep] = true;
			const isCss = dep.endsWith(".css");
			for (let i = links.length - 1; i >= 0; i--) {
				const link = links[i];
				if (link.href === dep && (!isCss || link.rel === "stylesheet")) return;
			}
			const link = document.createElement("link");
			link.rel = isCss ? "stylesheet" : scriptRel;
			if (!isCss) link.as = "script";
			link.crossOrigin = "";
			link.href = dep;
			if (cspNonce) link.setAttribute("nonce", cspNonce);
			document.head.appendChild(link);
			if (isCss) return new Promise((res, rej) => {
				link.addEventListener("load", res);
				link.addEventListener("error", () => rej(/* @__PURE__ */ new Error(`Unable to preload CSS for ${dep}`)));
			});
		}));
	}
	function handlePreloadError(err) {
		const e = new Event("vite:preloadError", { cancelable: true });
		e.payload = err;
		window.dispatchEvent(e);
		if (!e.defaultPrevented) throw err;
	}
	return promise.then((res) => {
		for (const item of res || []) {
			if (item.status !== "rejected") continue;
			handlePreloadError(item.reason);
		}
		return baseModule().catch(handlePreloadError);
	});
};
//#endregion
//#region src/components/Sliders/index.js
var splideModules = null;
var loadSplide = () => {
	splideModules ??= __vitePreload(() => import("./chunk.splide_v20261023.js"), []);
	return splideModules;
};
if (!customElements.get("secondary-hero-pxg-image-slider")) customElements.define("secondary-hero-pxg-image-slider", class SecondaryHeroPxgImageSlider extends HTMLElement {
	constructor() {
		super();
		loadSplide().then(({ Splide }) => {
			const count = this.dataset?.count;
			const splide = new Splide(this.querySelector(".splide"), {
				gap: "1rem",
				padding: {
					left: "0",
					right: "0"
				},
				perPage: parseInt(count),
				arrows: true,
				pagination: true,
				classes: {
					pagination: "splide__pagination pxg-splide-pagination !-bottom-9",
					arrow: "splide__arrow pxg-splide-arrow",
					prev: "splide__arrow--prev !-left-12",
					next: "splide__arrow--next !-right-9"
				},
				breakpoints: {
					768: {
						fixedWidth: "95%",
						perPage: 1,
						padding: {
							left: "24px",
							right: "24px"
						}
					},
					1259: {
						arrows: false,
						width: "100%"
					}
				}
			});
			const handleAria = () => {
				const splideArrows = this.querySelectorAll(".splide__arrow svg");
				if (splideArrows) for (const arrow of splideArrows) arrow.setAttribute("aria-hidden", "true");
			};
			splide.on("ready", handleAria);
			splide.on("overflow", (isOverflow) => {
				splide.options = {
					pagination: isOverflow,
					drag: isOverflow
				};
			});
			splide.mount();
		});
	}
});
if (!customElements.get("slider-component-multicol")) customElements.define("slider-component-multicol", class SliderComponentMulticol extends HTMLElement {
	constructor() {
		super();
		loadSplide().then(({ Splide }) => {
			const aTarget = this.querySelector(".splide");
			let mobileSettings = {};
			if (this.dataset.mobileEnabled === "true") mobileSettings = {
				perPage: this.dataset.mobileCols,
				arrows: false
			};
			else mobileSettings.destroy = true;
			let paginationPaddingClass = "!pb-4";
			if (this.dataset.hasCtaBtn === "true") paginationPaddingClass += " lg:!pb-0";
			const splide = new Splide(aTarget, {
				gap: "5rem",
				mediaQuery: "max",
				arrows: true,
				perPage: this.dataset.desktopCols,
				perMove: 1,
				focus: 0,
				omitEnd: true,
				pagination: true,
				rewind: true,
				classes: {
					pagination: "splide__pagination pxg-splide-pagination storytelling-card-slider !-bottom-7 " + paginationPaddingClass,
					arrow: "splide__arrow pxg-splide-arrow",
					prev: "splide__arrow--prev !-left-16 mt-[-40px]",
					next: "splide__arrow--next !-right-16 mt-[-40px]"
				},
				breakpoints: { 1023: mobileSettings }
			});
			const handleAria = () => {
				const splideArrows = this.querySelectorAll(".splide__arrow svg");
				if (splideArrows) for (const arrow of splideArrows) arrow.setAttribute("aria-hidden", "true");
			};
			splide.on("ready", handleAria);
			splide.on("overflow", (isOverflow) => {
				splide.options = {
					pagination: isOverflow,
					drag: isOverflow
				};
			});
			splide.mount();
		});
	}
});
if (!customElements.get("storytelling-card-slider")) customElements.define("storytelling-card-slider", class StorytellingCardSlider extends HTMLElement {
	constructor() {
		super();
		loadSplide().then(({ Splide, AutoScroll }) => {
			const isLargeCard = this.dataset?.cardSizeLarge;
			const autoscroll = this.dataset?.autoscroll;
			const splide = new Splide(this.querySelector(".splide"), {
				gap: "1rem",
				mediaQuery: "min",
				fixedWidth: "92%",
				padding: {
					left: "24px",
					right: "24px"
				},
				arrows: false,
				type: autoscroll ? "loop" : "slide",
				drag: autoscroll ? "free" : true,
				perMove: 1,
				classes: { pagination: "splide__pagination pxg-splide-pagination !-bottom-7" },
				breakpoints: !!isLargeCard ? {
					768: {
						fixedWidth: "32%",
						perPage: 3
					},
					1440: {
						fixedWidth: "",
						width: "1872px",
						padding: {
							left: "0",
							right: "0"
						},
						perPage: 4
					}
				} : {
					768: {
						fixedWidth: "45%",
						perPage: 3
					},
					992: { fixedWidth: "38%" },
					1440: {
						fixedWidth: "",
						width: "1872px",
						padding: {
							left: "0",
							right: "0"
						},
						perPage: 4
					}
				}
			});
			splide.on("overflow", (isOverflow) => {
				splide.options = {
					pagination: isOverflow,
					drag: isOverflow
				};
			});
			if (autoscroll) splide.mount({ AutoScroll });
			else splide.mount();
		});
	}
});
if (!customElements.get("image-gallery-pxg")) customElements.define("image-gallery-pxg", class ImageGalleryPxg extends HTMLElement {
	constructor() {
		super();
		loadSplide().then(({ Splide }) => {
			const splide = new Splide(this.querySelector(".splide"), {
				gap: "24px",
				perPage: 4,
				pagination: true,
				arrows: false,
				type: "loop",
				classes: { pagination: "splide__pagination pxg-splide-pagination !-bottom-10" },
				breakpoints: {
					768: {
						perPage: 1,
						padding: {
							left: "0px",
							right: "0px"
						}
					},
					1024: { perPage: 2 }
				}
			});
			splide.on("overflow", (isOverflow) => {
				splide.options = {
					pagination: isOverflow,
					drag: isOverflow
				};
			});
			splide.mount();
		});
	}
});
if (!customElements.get("product-list-slider")) customElements.define("product-list-slider", class ProductListSlider extends HTMLElement {
	constructor() {
		super();
		loadSplide().then(({ Splide }) => {
			const aTarget = this.querySelector(".splide");
			const splideList = this.querySelector(".splide__list");
			const slideItems = this.querySelectorAll(".splide__slide");
			const splide = new Splide(aTarget, {
				gap: "1rem",
				mediaQuery: "min",
				fixedWidth: "92%",
				padding: {
					left: "24px",
					right: "24px"
				},
				arrows: false,
				pagination: true,
				classes: { pagination: "splide__pagination pxg-splide-pagination !-bottom-10" },
				breakpoints: {
					768: {
						fixedWidth: "",
						perPage: 2,
						arrows: false
					},
					1024: {
						fixedWidth: "",
						perPage: slideItems.length < 4 ? 3 : slideItems.length,
						arrows: false
					}
				}
			});
			splide.on("overflow", (isOverflow) => {
				splideList.classList.toggle("justify-center", !isOverflow);
				splide.options = {
					pagination: isOverflow,
					drag: isOverflow
				};
			});
			splide.mount();
		});
	}
});
if (!customElements.get("pxg-store-slider-section")) customElements.define("pxg-store-slider-section", class PxgStoreSliderSection extends HTMLElement {
	constructor() {
		super();
		loadSplide().then(({ Splide }) => {
			const splide = new Splide(this.querySelector(".splide"), {
				gap: "1rem",
				mediaQuery: "min",
				fixedWidth: "92%",
				padding: {
					left: "24px",
					right: "24px"
				},
				arrows: true,
				pagination: false,
				classes: {
					arrow: "splide__arrow !top-1/3",
					pagination: "splide__pagination pxg-splide-pagination !-bottom-10"
				},
				breakpoints: {
					768: {
						padding: {
							left: "0",
							right: "0"
						},
						fixedWidth: "",
						perPage: 3,
						arrows: false,
						pagination: true
					},
					1024: {
						fixedWidth: "",
						padding: {
							left: "0",
							right: "0"
						},
						perPage: 4,
						arrows: false
					},
					1280: {
						fixedWidth: "",
						padding: {
							left: "0",
							right: "0"
						},
						perPage: 5,
						arrows: false
					}
				}
			});
			const handleAria = () => {
				const splideArrows = this.querySelectorAll(".splide__arrow svg");
				if (splideArrows) for (const arrow of splideArrows) arrow.setAttribute("aria-hidden", "true");
			};
			splide.on("ready", handleAria);
			splide.on("overflow", (isOverflow) => {
				splide.options = {
					arrows: isOverflow,
					drag: isOverflow,
					breakpoints: {
						768: { pagination: isOverflow },
						1024: { pagination: isOverflow },
						1280: { pagination: isOverflow }
					}
				};
			});
			splide.mount();
		});
	}
});
if (!customElements.get("product-media-slider")) customElements.define("product-media-slider", class ProductMediaSlider extends HTMLElement {
	constructor() {
		super();
		this.splideReady = loadSplide().then(({ Splide }) => {
			this.mainSlider = this.querySelector(".product-media-slider");
			this.thumbnailSlider = this.querySelector(".thumbnail-slider");
			this.thumbnailSlider.style.height = "fit-content";
			this.thumbnailSlider.style.paddingBlock = "70px";
			this.main = new Splide(this.mainSlider, {
				type: "loop",
				perPage: 1,
				gap: "1rem",
				pagination: false
			});
			this.thumbnails = new Splide(this.thumbnailSlider, {
				direction: "ttb",
				fixedWidth: "94px",
				fixedHeight: "94px",
				height: "420px",
				heightRatio: 1,
				gap: "16px",
				rewind: true,
				pagination: false,
				isNavigation: true,
				perPage: 4,
				arrows: true
			});
			const handleAria = () => {
				const splideArrows = this.querySelectorAll(".splide__arrow svg");
				if (splideArrows) for (const arrow of splideArrows) arrow.setAttribute("aria-hidden", "true");
			};
			this.main.on("ready", handleAria);
			this.thumbnails.on("ready", handleAria);
		});
	}
	connectedCallback() {
		this.splideReady.then(() => {
			const mainOverflow = (isOverflow) => {
				this.main.options = {
					arrows: isOverflow,
					drag: isOverflow
				};
			};
			const thumbnailsOverflow = (isOverflow) => {
				this.thumbnails.options = {
					arrows: isOverflow,
					drag: isOverflow
				};
			};
			this.main.on("overflow", mainOverflow);
			this.thumbnails.on("overflow", thumbnailsOverflow);
			this.main.sync(this.thumbnails);
			this.main.mount();
			this.thumbnails.mount();
		});
	}
});
//#endregion
//#region src/components/Accordion/index.js
if (!customElements.get("card-accordion-pxg")) customElements.define("card-accordion-pxg", class CardAccordionPxg extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector("details");
		const initialOpen = this.mainDetailsToggle.dataset?.initialOpen;
		const mediaQuery = window.matchMedia("(min-width: 768px)");
		const handleTabletChange = (e) => {
			if (e.matches) this.mainDetailsToggle.setAttribute("open", "");
			else if (!initialOpen) this.mainDetailsToggle.removeAttribute("open");
		};
		mediaQuery.addEventListener("change", handleTabletChange);
		handleTabletChange(mediaQuery);
	}
});
if (!customElements.get("secondary-nav-pxg")) customElements.define("secondary-nav-pxg", class SecondaryNavPxg extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector("details");
		this.isMobile = false;
		this.onBodyClick = this.handleBodyClick.bind(this);
		this.querySelectorAll("[data-click-close]").forEach((item) => {
			item.addEventListener("click", (event) => {
				if (this.isMobile) window.requestAnimationFrame(() => this.mainDetailsToggle.removeAttribute("open"));
			});
		});
		const mediaQuery = window.matchMedia("(min-width: 1024px)");
		const handleTabletChange = (e) => {
			if (e.matches) {
				this.isMobile = false;
				this.mainDetailsToggle.setAttribute("open", "");
				window.removeEventListener("click", this.onBodyClick);
			} else {
				this.isMobile = true;
				window.addEventListener("click", this.onBodyClick);
				this.mainDetailsToggle.removeAttribute("open");
			}
		};
		mediaQuery.addEventListener("change", handleTabletChange);
		handleTabletChange(mediaQuery);
	}
	handleBodyClick(e) {
		if (!this.contains(e.target)) {
			if (this.mainDetailsToggle.hasAttribute("open")) this.mainDetailsToggle.removeAttribute("open");
		}
	}
});
//#endregion
//#region src/components/CustomElements/AffirmWatcher.js
if (!customElements.get("affirm-watcher")) customElements.define("affirm-watcher", class AffirmWatcher extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", this.affirmRefresh);
		else this.affirmRefresh();
	}
	affirmRefresh() {
		if ("affirm" in window) window?.affirm?.ui?.refresh();
	}
});
//#endregion
